var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1693,
    y: -1157,
    width: 5220.85,
    height: 2167,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 925,
    transform: "translate(-1290 -664)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1082,
    y: -600,
    width: 1232,
    height: 861,
    fill: "#F1F6FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1189,
    height: 568.001,
    transform: "translate(-1056 -474)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25155 3.41866L9.53141 9.16585C9.69562 9.30268 9.8872 9.35742 10.0788 9.35742C10.2703 9.35742 10.4619 9.30268 10.6261 9.16585L17.906 3.41866V6.81224C18.3986 6.70277 18.9186 6.64803 19.4386 6.64803C19.5207 6.64803 19.5754 6.64803 19.6575 6.64803V1.39346C19.6575 0.900846 19.247 0.5177 18.7544 0.5177H1.37577C0.883151 0.5177 0.5 0.900846 0.5 1.39346V13.1341C0.5 13.6268 0.883151 14.0099 1.37577 14.0099H12.0493C12.0493 13.4078 12.1314 12.8331 12.2682 12.2584H2.25155V3.41866ZM16.4829 2.26922L10.0788 7.33222L3.67468 2.26922H16.4829Z",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.034 13.6815H24.9119C24.7477 10.7806 22.3667 8.48169 19.4383 8.48169C16.4005 8.48169 13.9374 10.9448 13.9374 13.9826C13.9374 17.0204 16.4005 19.4834 19.4383 19.4834C20.1499 19.4834 20.8615 19.3466 21.5183 19.0729C21.9562 18.8814 22.1751 18.3887 22.0109 17.9235C21.8193 17.4856 21.3267 17.2667 20.8615 17.4309C20.4236 17.6225 19.931 17.7046 19.4657 17.7046C17.3857 17.7046 15.7163 16.0351 15.7163 13.9552C15.7163 11.8753 17.3857 10.2058 19.4657 10.2058C21.4362 10.2058 23.0235 11.7111 23.1877 13.6268H22.1477C21.792 13.6268 21.573 14.0099 21.7646 14.3383L23.7351 17.5677C23.9267 17.8688 24.3372 17.8688 24.5288 17.5677L26.4445 14.3931C26.6087 14.092 26.3898 13.6815 26.034 13.6815Z",
    fill: "#1890FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 925,
    fill: "white",
    transform: "translate(-1290 -664)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1141,
    height: 448,
    fill: "white",
    transform: "translate(-1032 -410)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.5,
    height: 56,
    fill: "white",
    transform: "translate(-15.5 -17.9994)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.5,
    height: 56,
    fill: "white",
    transform: "translate(0.5 -17.9994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendVerificationIcon);
export default __webpack_public_path__ + "static/media/resend-verification-icon.2f2ee7e9deb11fca50ad43d7c259164a.svg";
export { ForwardRef as ReactComponent };